const PopupGroupConstants = {
  POPUP_GROUP_CREATE: 'POPUP_GROUP_CREATE',
  POPUP_GROUP_ACTIVE_CLEAR: 'POPUP_GROUP_ACTIVE_CLEAR',
  POPUP_GROUP_POPUP_ADD: 'POPUP_GROUP_POPUP_ADD',
  POPUP_GROUP_POPUP_REMOVE: 'POPUP_GROUP_POPUP_REMOVE',
  POPUP_GROUP_QUESTION_UPDATE: 'POPUP_GROUP_QUESTION_UPDATE',
  POPUP_GROUP_ACTIVE_SET: 'POPUP_GROUP_ACTIVE_SET',
  POPUP_GROUP_EDIT_GROUP_START: 'POPUP_GROUP_EDIT_GROUP_START',
  POPUP_GROUP_EDIT_GROUP_END: 'POPUP_GROUP_EDIT_GROUP_END',
};

export default PopupGroupConstants;



// WEBPACK FOOTER //
// ./src-react/PopupGroup/PopupGroupConstants.jsx